import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX } from '../utils/constants';

export interface StatusGuideEntry {
  key: string;
  label: string;
  description: string;
}

export interface StatusGuide {
  guide_type: string;
  label: string;
  entries: StatusGuideEntry[];
}

export interface StatusGuidesResponse {
  guides: StatusGuide[];
}

export interface UpdateStatusGuideEntryRequest {
  guide_type: string;
  entry_key: string;
  description: string;
}

export const getStatusGuides = async (): Promise<StatusGuidesResponse> => {
  const { data } = await axiosInstance.get<StatusGuidesResponse>(
    `${API_V1_PREFIX}app-cms/status-guides`
  );
  return data;
};

export const updateStatusGuideEntry = async (
  payload: UpdateStatusGuideEntryRequest
): Promise<StatusGuide> => {
  const { data } = await axiosInstance.put<StatusGuide>(
    `${API_V1_PREFIX}app-cms/status-guides/entry`,
    payload
  );
  return data;
};
